import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
let DxListMessageOptions = class DxListMessageOptions {
    constructor() {
        this._showMessageLink = false;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get subtitle() {
        return this._subtitle;
    }
    set subtitle(value) {
        this._subtitle = value;
    }
    get icon() {
        return this._icon;
    }
    set icon(value) {
        this._icon = value;
    }
    get showMessageLink() {
        return this._showMessageLink;
    }
    set showMessageLink(value) {
        this._showMessageLink = value;
    }
    get messageLinkTitle() {
        return this._messageLinkTitle;
    }
    set messageLinkTitle(value) {
        this._messageLinkTitle = value;
    }
};
tslib_1.__decorate([
    jsonArrayMember(String, { name: "title", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxListMessageOptions.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: "subtitle", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxListMessageOptions.prototype, "_subtitle", void 0);
tslib_1.__decorate([
    jsonMember({ name: "icon", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListMessageOptions.prototype, "_icon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "showMessageLink", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxListMessageOptions.prototype, "_showMessageLink", void 0);
tslib_1.__decorate([
    jsonMember({ name: "messageLinkTitle", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxListMessageOptions.prototype, "_messageLinkTitle", void 0);
DxListMessageOptions = tslib_1.__decorate([
    jsonObject
], DxListMessageOptions);
export { DxListMessageOptions };
